import * as ReportActionTypes from '../actions/reports';
import initialState from './initialState';

export default (state=initialState.reports, action) => {

    const { payload, type } = action;

    switch(type){
        case ReportActionTypes.GET_REVENUES_PENDING:
            return { ...state, errorReports: false, reportsLoading: true }

        case ReportActionTypes.GET_REVENUES_REJECTED:
            return { ...state, errorReports: true, reportsLoading: false , errorMessage: payload.reports.data }

        case ReportActionTypes.GET_REVENUES_FULFILLED:
            return { ...state, errorReports: false, reportsLoading: false, revenue_summary: payload.data }
            

        case ReportActionTypes.GET_REVENUE_REPORTS_PENDING:
        return { ...state, errorReports: false, reportsLoading: true }

        case ReportActionTypes.GET_REVENUE_REPORTS_REJECTED:
            return { ...state, errorReports: true, reportsLoading: false , errorMessage: payload.reports.data }

        case ReportActionTypes.GET_REVENUE_REPORTS_FULFILLED:
            return { ...state, errorReports: false, reportsLoading: false, revenue_summary: payload.data }


        case ReportActionTypes.GET_MCI_REPORTS_PENDING:
            return { ...state, errorReports: false, mci_loading: true }

        case ReportActionTypes.GET_MCI_REPORTS_REJECTED:
            return { ...state, errorReports: true, mci_loading: false , errorMessage: payload.data }

        case ReportActionTypes.GET_MCI_REPORTS_FULFILLED:
            return { ...state, errorReports: false, mci_loading: false, mci: payload.data }
        

        case ReportActionTypes.GET_POLICY_REPORTS_PENDING:
            return { ...state, errorReports: false, policies_loading: true }

        case ReportActionTypes.GET_POLICY_REPORTS_REJECTED:
            return { ...state, errorReports: true, policies_loading: false , errorMessage: payload.data }

        case ReportActionTypes.GET_POLICY_REPORTS_FULFILLED:
            return { ...state, errorReports: false, policies_loading: false, policies: payload.data }
        

        case ReportActionTypes.GET_GOODS_REPORTS_PENDING:
            return { ...state, errorReports: false, goods_loading: true }

        case ReportActionTypes.GET_GOODS_REPORTS_REJECTED:
            return { ...state, errorReports: true, goods_loading: false , errorMessage: payload.data }

        case ReportActionTypes.GET_GOODS_REPORTS_FULFILLED:
            return { ...state, errorReports: false, goods_loading: false, goods: payload.data }


        case ReportActionTypes.GET_SALES_REPORTS_PENDING:
            return { ...state, errorReports: false, sales_loading: true }

        case ReportActionTypes.GET_SALES_REPORTS_REJECTED:
            return { ...state, errorReports: true, sales_loading: false , errorMessage: payload.data }

        case ReportActionTypes.GET_SALES_REPORTS_FULFILLED:
            return { ...state, errorReports: false, sales_loading: false, sales: payload.data }


        case ReportActionTypes.GET_MAP_POLICY_REPORTS_PENDING:
            return { ...state, map_policy_loading: true }

        case ReportActionTypes.GET_MAP_POLICY_REPORTS_REJECTED:
            return { ...state, map_policy_loading: false , errorMessage: payload.data }

        case ReportActionTypes.GET_MAP_POLICY_REPORTS_FULFILLED:
            return { ...state, map_policy_loading: false, map_policies: payload.data }
        
        
        case ReportActionTypes.GET_WORLD_GEOJSON_PENDING:
            return { ...state, geojson_loading: true }

        case ReportActionTypes.GET_WORLD_GEOJSON_REJECTED:
            return { ...state, geojson_loading: false , errorMessage: payload.data }

        case ReportActionTypes.GET_WORLD_GEOJSON_FULFILLED:
            return { ...state, geojson_loading: false, geojson: payload.data }

        
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reports.js